import {
  ACCESS_TOKEN_COOKIE,
  USER_ROLE_COOKIE,
} from "@/lib/auth/session-cookie-options"
import { deleteCookie } from "@/utils/cookies"

const SESSION_ENDPOINT = "/api/auth/session"

export type SetAuthSessionInput = {
  accessToken: string
  maxAge: number
  role?: string
}

/** Persist auth cookies via the Next route handler (HttpOnly + Secure + SameSite). */
export async function setAuthSessionCookie(
  input: SetAuthSessionInput
): Promise<void> {
  const res = await fetch(SESSION_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      accessToken: input.accessToken,
      maxAge: input.maxAge,
      role: input.role,
    }),
    credentials: "same-origin",
  })
  if (!res.ok) {
    throw new Error(`Failed to establish session cookie (${res.status})`)
  }
}

/** Clear HttpOnly auth cookies and any legacy client-readable copies. */
export async function clearAuthSessionCookie(): Promise<void> {
  try {
    await fetch(SESSION_ENDPOINT, {
      method: "DELETE",
      credentials: "same-origin",
    })
  } catch {
    // Best-effort; still clear legacy cookies below.
  }
  deleteCookie(ACCESS_TOKEN_COOKIE)
  deleteCookie(USER_ROLE_COOKIE)
}
